export default __webpack_public_path__ + "static/media/MP_Profile_Language_01.b06ebcb3.png";